import * as React from "react"
import * as ReactDOM from "react-dom"
import { Moment } from 'moment';

import { RentalAdvertPricing } from '../../../types/types'
import { FocusedInputShape } from 'react-dates';

import { default as AdvertPeriodPicker } from '../../../utils/period_picker/AdvertPeriodPicker'
import { StartEnd } from '../../../utils/period_picker/PeriodPicker'
import * as PeopleEventEmitter from '../../../utils/period_picker/PeopleEventEmitter'
import Error from './error'

declare var I18n : { locale: string, t: (_:string) => string }

type Props = {
  arrival_date: Moment
  departure_date: Moment
  advert_id: number
  onDatesChange: (arg: { startDate: Moment | null, endDate: Moment | null }) => void
  onMaxPeopleChange: (value: number) => void
  max_people_select: number
  max_people: number
  closeScreen: () => void
  onFocusChange: (fi: FocusedInputShape) => void
  focusedInput: FocusedInputShape
  pricing: RentalAdvertPricing
}

type State = {
}

export default class PeriodSelection extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
    this.state = {
    }
  }

  componentDidUpdate(prevProps : Props, prevState : State) {
    if (this.props.max_people != prevProps.max_people) {
      PeopleEventEmitter.publish({max_people: this.props.max_people, source: 'booking_form'})
    }
  }

  render() {
    let options = []
    for(let i = 1; i <= this.props.max_people_select; i++) {
      options.push(<option key={`people_${i}`} value={i}>{i}</option>)
    }
    return (
      <div>
        <button className="conversion-box__close" onClick={() => this.props.closeScreen()}>
          <span className="icon-cross"></span>
        </button>
        <div className="conversion-box__datepicker">
          <div className="conversion-box__labels">
            <span className="conversion-box__labels--when">{I18n.t("rental_adverts.booking_form.when")}</span>
          </div>
          <AdvertPeriodPicker
            startDate={this.props.arrival_date}
            endDate={this.props.departure_date}
            advert_id={this.props.advert_id}
            onDatesChange={(range: StartEnd) => this.props.onDatesChange(range)}
            onFocusChange={this.props.onFocusChange}
            focusedInput={this.props.focusedInput}
            close={() => this.props.closeScreen()}
          />
        </div>
        <div className="conversion-box__persons ">
          <div className="conversion-box__labels">
            <span className="conversion-box__labels--when">{I18n.t("rental_adverts.booking_form.max_people")}</span>
          </div>
          <select
            value={this.props.max_people || ''}
            onChange={(e) => this.props.onMaxPeopleChange(parseInt(e.target.value))}>
            {options}
          </select>
        </div>
        {
          this.props.pricing && this.props.pricing.error ?
          <div className="conversion-box__error">
            <Error
              pricing={this.props.pricing}
              close={() => this.props.closeScreen()}
            />
          </div>
          : null
        }
        <div className="conversion-box__button">
          {
            this.props.pricing ?
              (
                this.props.pricing.bookingLink
                ?
                <a href={this.props.pricing.bookingLink} className="btn btn--primary btn--block">{this.props.pricing.bookLabel}</a>
                :
                <a href="#" className="btn btn--primary disabled">{this.props.pricing.bookLabel}</a>

              )
            : null
          }
        </div>
        {
          this.props.pricing && this.props.pricing.withBookingModule ?
            <p className="conversion-box--secure-payment-text">{I18n.t('bookings.secure_payments.disclaimer')}</p>
          : null
        }
      </div>
    )
  }
}
